import React from 'react';
import './styles/global.css';  // Import global styles
import { createRoot } from 'react-dom/client';
import App from './App'; // Ensure your App component is properly imported
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://85e5268205c45042595a0b2fc1043c1d@o1224136.ingest.us.sentry.io/4508972346441728"
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
